<template>
  <div>
    <default-dialog ref="dialog" fullscreen :loading="loading.building">
      <template slot="title">
        Detalhes da obra
      </template>
      <template slot="content">
        <v-expansion-panels v-model="expansion_panels" multiple flat active-class="elevation-4" popout>
          <v-expansion-panel class="exp-panel" ripple>
            <v-expansion-panel-header class="red--text font-weight-bold">
              <div>
                <v-icon size="19" color="red">mdi-information</v-icon>
                Informações básicas
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-title class="d-flex align-center justify-end">
                </v-card-title>
                <v-card-text>
                  <div>
                    <v-col cols='12' class="d-flex justify-end">
                      <f-btn edit small class="ml-2" @click="dialog.building = true"></f-btn>
                    </v-col>
                    <DialogEditBuilding
                      :dialog="dialog.building" 
                      :model_building="building"
                      @closeDialog="dialog.building = false"
                      @updated="handleRefresh"
                    ></DialogEditBuilding>
                    <BuildingForm :building="building" read_only ></BuildingForm>
                    <v-btn @click="changeStatus" small :class="status_map[building.status]?.color">
                      <v-icon small left>{{ status_map[building.status]?.icon }}</v-icon>
                      <span>{{ status_map[building.status]?.text }}</span>
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel class="exp-panel" ripple>
            <v-expansion-panel-header class="red--text font-weight-bold">
              <div>
                <v-icon size="19" color="red">mdi-map</v-icon>
                Endereço
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-title class="d-flex align-center justify-end">
                </v-card-title>
                <v-card-text>
                  <div>
                    <v-col cols='12' class="d-flex justify-end">
                      <f-btn edit small class="ml-2" @click="dialog.address = true"></f-btn>
                    </v-col>
                    <DialogEditAddress
                      :dialog="dialog.address" 
                      :model_address="building.address"
                      @closeDialog="dialog.address = false"
                      @updated="handleRefresh"
                    ></DialogEditAddress>
                    <AddressForm :address="building.address" read_only ></AddressForm>
                  </div>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>
      </template>
      <template slot="actions">
        <f-btn close @click="goBack()"></f-btn>
      </template>
    </default-dialog>
    <dialog-loading v-if="saving" loadingText="Salvando..."></dialog-loading>
  </div>
</template>


<script>
import Api from '@/api/index';

export default {
  name: "ShowBuilding",
  components: {
    BuildingForm: ()=> import("@/_backoffice/_registrations/components/buildings/forms/BuildingForm.vue"),
    AddressForm: ()=> import("@/_backoffice/_registrations/components/shared/forms/AddressForm.vue"),
    DialogEditAddress: () => import('@/_backoffice/_registrations/components/shared/edit/DialogEditAddress.vue'),
    DialogEditBuilding: () => import('@/_backoffice/_registrations/components/buildings/DialogEditBuilding.vue'),
  },
  data() {
    return {
      dialog: true,
      saving: false,
      dialog: {
        address: false,
        building: false,
      },
      loading: {
        building: false,
      },
      expansion_panels: [0, 1],
      building: {},
      status_map:{
        "active": {text:"Desativar obra", color:"error", icon:"mdi-office-building-minus"},
        "disabled": {text:"Ativar obra", color:"success", icon:"mdi-office-building-plus"},
      }
    }
  },
  methods: {
    getData(){
      this.$refs.dialog.openDialog()
      this.getBuilding()
    },
    handleRefresh(){
      this.dialog.address = false
      this.dialog.building = false
      this.getData()
    },
    changeStatus(){
      let updated_building = {id: this.building.id, status: null}
      if(this.building.status == "active"){
        updated_building.status = "disabled"
      }else{
        updated_building.status = "active"
      }
      this.swallConfirmation({
          title: 'Deseja mudar status da obra?',
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {
            this.saving = true
            Api.Building.update(updated_building).then(()=>{
              this.successSaved()
            }).catch(()=>{
              this.errorUpdated()
            }).finally(()=>{
              this.saving = false
              this.getBuilding()

            })
          }
        })
    },
    getBuilding(){
      this.loading.building = true
      let id = this.$route.params.id
      Api.Building.show(id).then((res)=>{
        this.building = {...res.data}
      }).finally(()=>{
        this.loading.building = false
      })
    },
    goBack(){
      this.$router.push({name:"Buildings"})
    },
  },
  mounted() {
    this.getData();
  },
}
</script>
